module.exports = __webpack_public_path__ + "static/media/covid.206e7d11.svg";